export const ACCESS_ROUTES = ["/auth"];

export const UNPROTECTED_ROUTES = ["/document", "/auth", "/qr"];

export const APP_URLS = {
  LOGIN: "/",
  DASHBOARD: "/admin",
  REPORTS: "/admin/reports",
  COMPANIES: "/admin/companies",
  VEHICLES: "/admin/vehicles",
  VEHICLE_LOANS: "/admin/vehicle-loans",
  ACTIVES: "/admin/actives",
  ACTIVE_LOANS: "/admin/active-loans",
  ADMINISTRATION: "/admin/administracion",
  ADMINISTRATION_COMPANY: "/admin/administracion/:company",
  ADMINS: "/admin/users",
  ROLES: "/admin/roles",
  TEMPLATES: "/admin/templates",
  PROYECTS: "/admin/proyects",
  PRODUCTS: "/admin/products",
  INVOICES: "/admin/invoices",
  CARTA_PORTE: "/admin/carta-porte",
  SHOPPING: "/admin/shoppings",
  SHOPPING_V2: "/admin/shoppings-v2",
  STORE: "/admin/store",
  PENDING_PRODUCTS: "/admin/store/pending-products",
  WAREHOUSES: "/admin/store/warehouses",
  SEMINUEVOS: "/admin/store/seminuevos",
  PROYECT_CREATOR: "/admin/proyect/creator",
  DOCUMENTS: "/admin/documents",
  DOCUMENT_CREATOR: "/admin/document/creator",
  PROFILE: "/admin/profile",
  EMPLOYEES: "/admin/employees",
  NOTIFICATIONS: "/admin/notifications",
  MOVEMENTS: "/admin/store/movements",
  TRANSFERS: "/admin/store/transfers",
  STOCK_MODIFICATIONS: "/admin/store/stock-modifications",
  SETTINGS: "/admin/settings",
  FORMATS: "/admin/settings/formats",
  PAYROLL: "/admin/payrolls",
  EMPLOYEES_EXPENSES: "/admin/employees-expenses",
  NOVEDADES: "/admin/novedades",
  WARRANTIES: "/admin/warranties",
  WARRANTY_TICKETS: "/admin/warranty-tickets",
  BITACORAS: "/admin/bitacoras",
  BONOS: "/admin/bonos",
  TOOLS_CATALOG: "/admin/tools/catalog",
  TOOLS_STOCK: "/admin/tools/stock",
  TOOLS_ADJUSTMENTS: "/admin/tools/adjustments",
  TOOLS_MOVEMENTS: "/admin/tools/movements",
  EMPLOYEE_DISCOUNTS: "/admin/employee-discounts",
  CUSTOMER_QUOTATIONS: "/admin/customer-quotations",
};

export const STATUS_DOCUMENT = [
  {
    slug: "COMPLETADO",
    color: "#4CAF50",
  },
  {
    slug: "PENDIENTE",
    color: "#FB8C00",
  },
];

export const STATUS_VOBO = [
  {
    slug: "ACEPTADO",
    color: "#4CAF50",
  },
  {
    slug: "PENDIENTE",
    color: "#FB8C00",
  },
  {
    slug: "RECHAZADO",
    color: "red",
  },
];

export const API_URL =
  process.env.REACT_APP_API_URL || "http://localhost:3000/v1";
